/* eslint-disable @typescript-eslint/no-unused-vars */
import { store } from '../../redux/store';
import * as XLSX from 'xlsx-js-style';
import FileSaver from 'file-saver';
import moment from 'moment';
import { PORTAL_TYPES, PORTAL_TYPES_DEFAULT_ROUTE } from '../constants/roles';
import { roleAccessed } from '../../redux/apis/authAPIs';
import {
	addUserRoles,
	setCurrentUserRole,
	setDirectAccess
} from '../../redux/features/auth-slice';
import { GetTenantDetails } from '../../redux/apis/tenantAPIs';
import { sortLinks } from './sortFunction';

export const formatBytes = (bytes: any, decimals = 2) => {
	if (!+bytes) return '0 Bytes';
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
export const fixDecimal = (number: any, decimals = 0) => {
	const global = store.getState();
	let points = decimals;
	if (!decimals) {
		if (global?.configuration?.appSetting?.decimal_points != undefined) {
			points = global?.configuration?.appSetting?.decimal_points;
		}
	}
	const n = 0;
	if (!+number) return n.toFixed(points);
	return number.toFixed(points); // || 2
};
export const isObjectEmpty = (objectName: any) => {
	return objectName ? Object.keys(objectName).length === 0 : true;
};
export const downloadFromUrl = async (fileUrl: any) => {
	let url = fileUrl;
	if (url.includes('.csv')) {
		const response = await fetch(url);
		const csvData = await response.text();
		const blob = new Blob([csvData], { type: 'text/csv' });
		url = window.URL.createObjectURL(blob);
	}
	const link: any = document.createElement('a');
	link.href = url;
	link.setAttribute('download', fileUrl.substring(fileUrl.lastIndexOf('/') + 1));
	document.body.appendChild(link);
	link.click();
	link.parentNode.removeChild(link);
};
export const getFileType = (response: any) => {
	const signature = response.slice(0, 4);
	switch (signature) {
		case 'PK\x03\x04':
			return 'xlsx';
		case '\uFEFF':
			return 'csv';
		default:
			console.error('Unknown file type');
			return null;
	}
};
export const downloadFromUrlCSV = async (urls: string) => {
	const response = await fetch(urls);
	const csvData = await response.text();

	const blob = new Blob([csvData], { type: 'text/csv' });
	const url = window.URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', 'data.csv');

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};
export const openPdf = (basePdf: any, orderNo?: any) => {
	let byteCharacters: any = atob(basePdf);
	let byteNumbers = new Array(byteCharacters.length);
	for (let i = 0; i < byteCharacters.length; i++) {
		byteNumbers[i] = byteCharacters.charCodeAt(i);
	}
	let byteArray = new Uint8Array(byteNumbers);
	let file = new Blob([byteArray], { type: 'application/pdf;base64' });
	let fileURL = URL.createObjectURL(file);
	console.log(fileURL);
	window.open(fileURL);
	window.saveAs(fileURL, `${orderNo}_label.pdf`);
};
export const bytesToMegabytes = (bytes: any) => {
	return bytes / (1024 * 1024);
};
export const ec = (r: any, c: any) => {
	return XLSX.utils.encode_cell({ r: r, c: c });
};
export const styleData = (ws: any) => {
	const object = JSON.parse(JSON.stringify(ws));
	let variable = XLSX.utils.decode_range(object['!ref']);
	for (let R = 0; R <= variable.e.r; ++R) {
		for (let C = variable.s.c; C <= variable.e.c; ++C) {
			if (R < 7 && ws[ec(R, C)] && C > 0) {
				ws[ec(R, C)].s = {
					border: {
						top: {
							style: 'thin',
							color: { rgb: '4E81BB' }
						},
						bottom: {
							style: 'thin',
							color: { rgb: '4E81BB' }
						},
						left: {
							style: 'thin',
							color: { rgb: '4E81BB' }
						},
						right: {
							style: 'thin',
							color: { rgb: '4E81BB' }
						}
					}
				};
			}
			if (R === 8) {
				if (ws[ec(R, C)]) {
					ws[ec(R, C)].s = {
						font: {
							color: { rgb: 'FFFFFF' },
							bold: true,
							sz: '12'
						},
						fill: {
							fgColor: { rgb: '4E81BB' }
						},
						alignment: {
							vertical: 'left',
							horizontal: 'left'
						},
						border: {
							top: {
								style: 'thin',
								color: { rgb: '4E81BB' }
							},
							bottom: {
								style: 'thin',
								color: { rgb: '4E81BB' }
							},
							left: {
								style: 'thin',
								color: { rgb: '4E81BB' }
							},
							right: {
								style: 'thin',
								color: { rgb: '4E81BB' }
							}
						}
					};
				}
			}
			if (R > 8) {
				if (ws[ec(R, C)]) {
					ws[ec(R, C)].s = {
						font: {
							color: { rgb: '000000' },
							sz: '12'
						},
						fill: {
							fgColor: { rgb: R % 2 === 0 ? 'd5e1ee' : 'aec5df' }
						},
						alignment: {
							vertical: 'center',
							horizontal: 'left'
						},
						border: {
							top: {
								style: 'thin',
								color: { rgb: 'bbc5d1' }
							},
							bottom: {
								style: 'thin',
								color: { rgb: 'bbc5d1' }
							},
							left: {
								style: 'thin',
								color: { rgb: 'bbc5d1' }
							},
							right: {
								style: 'thin',
								color: { rgb: 'bbc5d1' }
							}
						}
					};
				}
			}
		}
	}
	return ws;
};
export const createSalesSheet = (orderData: any, type?: any) => {
	if (orderData.items.length) {
		const data = orderData.items.map((item: any) => {
			return {
				// ItemCode: item.variant_item_number || item.product_item_number, //comment for old module
				ItemCode:
					type == 'old'
						? item?.variant_item_number || item?.product_item_number
						: item?.item_number,
				Quantity: item?.quantity,
				Price: fixDecimal(Number(item?.original_price)), //base_price + item?.tax
				TaxGroupID: ''
			};
		});
		const fileName = `${orderData.order_number}-sheet`;
		let ws = XLSX.utils.json_to_sheet(data);
		const wb: any = { Sheets: { data: ws }, SheetNames: ['data'] };
		const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const data2 = new Blob([excelBuffer], { type: '.xlsx' });
		FileSaver.saveAs(data2, fileName + '.xlsx');
	}
};
export const createSheet = (orderData: any, type?: any) => {
	const orderDetail = [
		['', 'Customer Name', orderData?.customer_name || ''],
		['', 'External ID', orderData?.external_id || ''],
		['', 'Sales Person', orderData?.sales_person_name || ''],
		[
			'',
			'Ordered by',
			orderData?.order_app_type === 'SALES_APP' ? 'Salesperson' : 'Customer'
		],
		['', 'Order Number', orderData?.order_number || ''],
		[
			'',
			'Order Date',
			`${moment(orderData?.created_at).format('DD/MM/YYYY')} @ ${moment(
				orderData?.created_at
			).format('hh:mm A')}`
		],
		['', 'Order Remarks', orderData?.order_remark || ''],
		['  ', '  ', '   '],
		[
			'#',
			'Sku',
			'Product Name',
			'Qty',
			'UOM',
			'price(from APP)',
			// 'price with tax',
			'Subtotal',
			// 'Subtotal with tax',
			'Comments'
		]
	];
	let data: Array<any> = orderData.items.map((items: any, index: number): any => {
		return [
			index + 1,
			// items.variant_item_number ?? items.product_item_number, //comment for old module
			type == 'old'
				? items?.variant_item_number ?? items?.product_item_number
				: items?.item_number,
			items?.product_name +
			(items?.variant_name ? ' - ' : '') +
			(items?.group_name ? items?.group_name + ' / ' : ' ') +
			(items?.variant_name ? items?.variant_name : ''),
			items.quantity,
			items.uom_name,
			fixDecimal(Number(items?.original_price)),
			// fixDecimal(Number(items?.base_price + items?.tax)),
			fixDecimal(Number(items.original_price) * Number(items.quantity)),
			// fixDecimal(
			// 	Number(items.base_price + items.tax) *
			// 	Number(items.quantity)
			// ),
			items?.item_comment?.toString()
		];
	});
	if (orderData.items.length > 0) {
		const sum = orderData.items.reduce((previousValue: any, currentValue: any) => {
			console.log(
				Number(
					previousValue.subtotal ||
					Number(
						fixDecimal(
							Number(previousValue.base_price + previousValue.tax) *
							Number(previousValue.quantity)
						)
					)
				),
				Number(
					fixDecimal(
						Number(currentValue.base_price + currentValue.tax) *
						Number(currentValue.quantity)
					)
				)
			);
			return {
				quantity: +previousValue.quantity + +currentValue.quantity,
				subtotal: fixDecimal(
					Number(
						previousValue.subtotal ||
						Number(
							fixDecimal(
								Number(
									// previousValue.base_price
									// + previousValue.tax
									previousValue.original_price
								) * Number(previousValue.quantity)
							)
						)
					) +
					Number(
						fixDecimal(
							Number(
								// currentValue.base_price
								//  + currentValue.tax
								currentValue.original_price
							) * Number(currentValue.quantity)
						)
					)
				)
				// subtotal_without_tax:
				// 	fixDecimal(Number(
				// 		previousValue.subtotal_without_tax ||
				// 		Number(
				// 			fixDecimal(
				// 				Number(
				// 					previousValue.original_price
				// 				) * Number(previousValue.quantity)
				// 			)
				// 		)
				// 	) +
				// 		Number(
				// 			fixDecimal(
				// 				Number(
				// 					currentValue.original_price
				// 				) * Number(currentValue.quantity)
				// 			)
				// 		))
			};
		});
		if (!sum.subtotal) {
			sum.subtotal = Number(
				fixDecimal(Number(sum.original_price) * Number(sum.quantity))
				// sum.base_price + sum.tax
			);
		}
		// if (!sum.subtotal_without_tax) {
		// 	sum.subtotal_without_tax = Number(
		// 		fixDecimal(
		// 			Number(sum.original_price) * Number(sum.quantity)
		// 		)
		// 	);
		// }
		data = [
			...data,
			...[
				[
					' ',
					'Total',
					' ',
					sum.quantity.toString(),
					' ',
					' ',
					// ' ',
					// sum.subtotal_without_tax.toString(),
					sum.subtotal.toString(),
					' '
				]
			]
		];
	}
	data = [...orderDetail, ...data];
	const fileName = `${orderData.order_number}-sheet`;
	let ws = XLSX.utils.aoa_to_sheet(data);
	const wsCols = [
		{ wch: 8 },
		{ wch: 30 },
		{ wch: 30 },
		{ wch: 30 },
		{ wch: 30 },
		{ wch: 30 },
		{ wch: 30 },
		{ wch: 50 },
		{ wch: 50 },
		{ wch: 50 }
	];
	ws['!cols'] = wsCols;
	ws = styleData(ws);
	const wb: any = { Sheets: { data: ws }, SheetNames: ['data'] };
	const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
	const data2 = new Blob([excelBuffer], { type: '.xlsx' });
	FileSaver.saveAs(data2, fileName + '.xlsx');
};

export const manageTimeStampInUrl = (previewImages: any, array: any = []) => {
	const newLink: any = [];
	if (previewImages?.length) {
		previewImages.map((link: any, arrayIndex: any) => {
			if (link) {
				const index = link?.indexOf('?timestamp=');
				if (array.length) {
					if (array.includes(arrayIndex)) {
						if (index === -1) {
							link = link + '?timestamp=' + Date.now();
						} else {
							const split = link?.split('?timestamp=');
							if (split[0]) {
								link = split[0] + '?timestamp=' + Date.now();
							}
						}
					}
				} else {
					if (index === -1) {
						link = link + '?timestamp=' + Date.now();
					} else {
						const split = link?.split('?timestamp=');
						if (split[0]) {
							link = split[0] + '?timestamp=' + Date.now();
						}
					}
				}
			}
			newLink.push(link);
			return link;
		});
	}
	return newLink;
};
export const accessDirect = (data: any, roles: any) => {
	// eslint-disable-next-line no-async-promise-executor
	return new Promise(async resolve => {
		const accessExist = JSON.parse(
			JSON.stringify(
				roles?.find(
					(item: any) =>
						(item.tenant_id?._id === data._id || '') &&
						item.role_id.portal_type !== PORTAL_TYPES.BRANCH_PORTAL
				) || ''
			)
		);
		if (accessExist) {
			const data2: any = {};
			data2.userRoleId = accessExist._id;
			if (accessExist?.role_id?.portal_type === PORTAL_TYPES.TENANT_PORTAL) {
				data2.tenantId = accessExist.tenant_id._id;
			}
			const response = await store.dispatch(roleAccessed(data2));
			if (response.type == 'roleAccessed/rejected') {
				return;
			}
			await store.dispatch(setCurrentUserRole(accessExist));
			const portalType: string = accessExist.role_id.portal_type;
			// const defaultRoute = PORTAL_TYPES_DEFAULT_ROUTE[portalType];
			let defaultRoute = PORTAL_TYPES_DEFAULT_ROUTE[portalType];

			if (accessExist.role_id.name === 'Contributor') {
				defaultRoute = PORTAL_TYPES_DEFAULT_ROUTE['CONTRIBUTOR'];
			} else if (accessExist.role_id.name === 'Warehouse Clerk') {
				defaultRoute = PORTAL_TYPES_DEFAULT_ROUTE['WAREHOUSE_CLERK'];
			} else if (accessExist.role_id.name === 'Accountant') {
				defaultRoute = PORTAL_TYPES_DEFAULT_ROUTE['ACCOUNTANT'];
			}
			await store.dispatch(setDirectAccess(false));
			resolve(defaultRoute);
		} else {
			const response = await store.dispatch(GetTenantDetails(data._id));
			let tenantRole = JSON.parse(
				JSON.stringify(
					roles.find(
						(item: any) => item.role_id.portal_type === 'TENANT_PORTAL'
					) || ''
				)
			);
			const superAdmin = JSON.parse(
				JSON.stringify(
					roles.find(
						(item: any) => item.role_id.portal_type === 'SYSTEM_PORTAL'
					) || ''
				)
			);
			if (!tenantRole || tenantRole === '') {
				tenantRole = JSON.parse(JSON.stringify(superAdmin));
				(tenantRole.role_id.name = 'Admin'),
					(tenantRole.role_id.portal_type = 'TENANT_PORTAL');
			} else {
				tenantRole.role_id.name = 'Admin';
			}
			tenantRole.tenant_id = response.payload.tenantDetails;
			tenantRole._id = superAdmin._id;
			await store.dispatch(addUserRoles(tenantRole));
			await store.dispatch(setCurrentUserRole(tenantRole));
			const portalType: string = tenantRole.role_id.portal_type;
			const defaultRoute = PORTAL_TYPES_DEFAULT_ROUTE[portalType];
			await store.dispatch(setDirectAccess(true));
			resolve(defaultRoute);
		}
	});
};
export const groupedObject = (data: any, key: any) => {
	const grouped: any = data.reduce((obj: any, item: any) => {
		obj[item[key]] = obj[item[key]] || [];
		obj[item[key]].push(item);
		return obj;
	}, {});
	for (const [key, value] of Object.entries(grouped)) {
		let images: any = value;
		images = images
			?.sort((a: any, b: any) => sortLinks(a, b))
			?.map((item: any) => item?.s3_url);
		grouped[key] = images;
	}
	return grouped;
};
export const arrayErrorResponse = (res: any) => {
	let message = '';
	if (res?.payload?.data?.length) {
		message = res.payload.data.join(' , ');
	} else {
		message = res?.payload?.message;
	}
	return message;
};
export const filterDuplicateData = (data: any, key: any) => {
	const uniqueData: any = [];
	const uniqueIds: any = [];
	for (let i = 0; i < data?.length; i++) {
		const item = data[i];
		if (!uniqueIds.includes(item[key])) {
			uniqueData.push(item);
			uniqueIds.push(item[key]);
		}
	}
	return uniqueData;
};
export const formatCommaNumber = (num: any) => {
	var n1, n2;
	num = num + '' || '';
	n1 = num.split('.');
	n2 = n1[1] || null;
	n1 = n1[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	num = n2 ? n1 + '.' + n2 : n1;
	return num;
};
export const dotCommaFormatWithDecimal = (num: any) => {
	let number = num;
	number = fixDecimal(number);
	return formatCommaNumber(number);
};

export const downloadPDF = async (pdf: any, name: string, share = false) => {
	const linkSource = `data:application/pdf;base64,${pdf}`;
	if (!share) {
		const downloadLink = document.createElement('a');
		const fileName = name;
		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	} else {
		const response = await fetch(linkSource);
		const blob = await response.blob();
		const file = new File([blob], name, { type: 'application/pdf' });
		const filesArray = [file];
		const shareData = {
			title: name,
			files: filesArray
		};
		await navigator.share(shareData);
	}
};

export const normalizeObjects = (arr: any) => {
	const allKeys = Array.from(new Set(arr.flatMap((obj: any) => Object.keys(obj))));
	arr.forEach((obj: any) => {
		allKeys.forEach((key: any) => {
			// eslint-disable-next-line no-prototype-builtins
			if (!obj.hasOwnProperty(key) || obj[key] === undefined) {
				obj[key] = ' ';
			}
		});
	});

	return arr;
};
export const extractArrayListFromTextarea = (textareaInput: any) => {
	let inputText = textareaInput.replace(/,/g, ' ').replace(/\n/g, ' ');

	let arrayList = inputText.split(' ');

	arrayList = arrayList.filter((item: any) => item !== '');

	return arrayList;
};
export const timeDuration = (time: string, startTime?: string, status?: string) => {
	let creationTime,
		currentTime = new Date();

	if (startTime) {
		creationTime = new Date(startTime);
		currentTime = new Date(time);
	} else {
		creationTime = new Date(time);
		currentTime = new Date();
	}

	// @ts-ignore
	const timeDifference = currentTime - creationTime;

	const minutesElapsed = Math.floor(timeDifference / (1000 * 60));
	const hoursElapsed = Math.floor(timeDifference / (1000 * 60 * 60));
	const daysElapsed = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
	const monthsElapsed = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 30));

	// Format the time elapsed
	let timeElapsedString = '';
	if (monthsElapsed > 0) {
		timeElapsedString = monthsElapsed + ' month' + (monthsElapsed === 1 ? '' : 's');
	} else if (daysElapsed > 0) {
		timeElapsedString = daysElapsed + ' day' + (daysElapsed === 1 ? '' : 's');
	} else if (hoursElapsed > 0) {
		timeElapsedString = hoursElapsed + ' hour' + (hoursElapsed === 1 ? '' : 's');
	} else {
		timeElapsedString =
			minutesElapsed + ' minute' + (minutesElapsed === 1 ? '' : 's');
	}
	if (status === 'shipped') {
		timeElapsedString = 'Fulfilled in ' + timeElapsedString;
	} else {
		timeElapsedString = timeElapsedString + ' ago';
	}
	return timeElapsedString;
};
export const timeDuration2 = (time: string) => {
	const creationTime = new Date(time);

	// Current date
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();
	const currentMonth = currentDate.getMonth();

	// Creation date
	const creationYear = creationTime.getFullYear();
	const creationMonth = creationTime.getMonth();

	// Calculate time difference in hours
	const timeDifferenceInHours = Math.floor(
		(currentDate.getTime() - creationTime.getTime()) / (1000 * 60 * 60)
	);

	// Calculate time elapsed in days and months
	const timeDifferenceInDays = Math.floor(
		(currentDate.getTime() - creationTime.getTime()) / (1000 * 60 * 60 * 24)
	);
	const monthsElapsed =
		(currentYear - creationYear) * 12 + (currentMonth - creationMonth);

	// Format the time elapsed
	let timeElapsedString = '';
	if (monthsElapsed > 0) {
		timeElapsedString =
			monthsElapsed + ' month' + (monthsElapsed === 1 ? '' : 's') + ' ago';
	} else if (timeDifferenceInDays > 0) {
		timeElapsedString =
			timeDifferenceInDays +
			' day' +
			(timeDifferenceInDays === 1 ? '' : 's') +
			' ago';
	} else if (timeDifferenceInHours > 0) {
		timeElapsedString =
			timeDifferenceInHours +
			' hour' +
			(timeDifferenceInHours === 1 ? '' : 's') +
			' ago';
	} else {
		const minutesElapsed = Math.floor(
			(currentDate.getTime() - creationTime.getTime()) / (1000 * 60)
		);
		timeElapsedString =
			minutesElapsed + ' minute' + (minutesElapsed === 1 ? '' : 's') + ' ago';
	}
	return timeElapsedString;
};

export const convertTime = (timeInMinutes: number) => {
	const hours = Math.floor(timeInMinutes / 60);
	const minutes = timeInMinutes % 60;
	const days = Math.floor(hours / 24);
	const remainingHours = hours % 24;
	let result = '';
	if (days > 0) {
		result += `${days} day${days > 1 ? 's' : ''} `;
	}
	if (remainingHours > 0) {
		result += `${remainingHours} hour${remainingHours > 1 ? 's' : ''} `;
	}
	if (minutes > 0) {
		result += `${minutes} minute${minutes > 1 ? 's' : ''}`;
	}
	return result.trim();
};
export const calculateDealStatus = (user: any) => {
	const from = new Date(user?.deal_from_date);
	const to = new Date(user?.deal_to_date);
	const now = new Date();
	// const nowUtc = new Date(now.toUTCString().slice(0, -4));
	if (
		user?.deal_status === 'PAUSED' ||
		user?.deal_status === 'CANCELLED' ||
		user?.deal_status === 'ARCHIVED'
	) {
		return user?.deal_status;
	}
	if (now >= from && now <= to) {
		return 'RUNNING';
	} else if (now < from) {
		return 'SCHEDULED';
	} else if (now > to) {
		return 'ENDED';
	} else {
		return 'CANCELLED';
	}
};

export const getPaginationDetail = (
	totalCount: number,
	perPageLimit: number,
	currentPage: number
) => {
	const startIdx = (currentPage - 1) * perPageLimit + 1;
	const endIdx = Math.min(startIdx + perPageLimit - 1, totalCount);
	return `${startIdx}-${endIdx} of ${totalCount} Results`;
};

export const percentFunction = (value: any) => {
	return value != '' || value != undefined ? value + '%' : '';
};

export const ImageSizeChange = (img: any, size: any) => {
	const url = img?.replace('/web/', '/' + size + '/');
	return url;
};

export const toUtcTime = (date: any) => {
	return new Date(date).toISOString();
};

export const toLocalTime = (date: any) => {
	const time = new Date(date);
	return moment(time).format('YYYY-MM-DDTHH:mm:ss.sssZ');
};

export const convertEndDate = (date: any) => {
	return toLocalTime(moment(date).add('days', 1).subtract('seconds', 1).toISOString());
};

export const sheetOrderProcessDeals = (items: any) => {
	const allItems: any = [];
	items.map((items: any) => {
		if (items?.deal_info) {
			// const modifyItem = structuredClone(items);
			const currentItem = structuredClone(items);
			if (currentItem?.deal_info?.deal_type === 'BULK_PRICING') {
				currentItem.original_price = currentItem?.deal_info.bulk_price;
				currentItem.item_comment.push(
					`(Deal: ${getDealName(currentItem?.deal_info?.deal_type)} - ${currentItem?.deal_info?.deal_name
					})`
				);
			}
			if (currentItem?.deal_info?.deal_type === 'DISCOUNT') {
				currentItem.original_price = currentItem?.deal_info.discounted_price;
				currentItem.item_comment.push(
					`(Deal: ${getDealName(currentItem?.deal_info?.deal_type)} - ${currentItem?.deal_info?.deal_name
					})`
				);
			}
			allItems.push(currentItem);
			const modifyItem = structuredClone(items);
			if (modifyItem?.deal_info?.deal_type === 'BUY_X_AND_GET_Y') {
				modifyItem.quantity = modifyItem?.deal_info.free_item_count;
				modifyItem.original_price = 0;
				modifyItem.dealGiftItem = true;
				modifyItem.item_comment = [
					`(Deal: ${getDealName(modifyItem?.deal_info?.deal_type)} - ${modifyItem?.deal_info?.deal_name
					})`
				];
				allItems.push(modifyItem);
			}

			// if (modifyItem?.deal_info?.deal_type === 'BUY_X_AND_GET_Y') {
			// 	allItems.push(items);
			// 	modifyItem.quantity = modifyItem?.deal_info.free_item_count;
			// 	modifyItem.original_price = 0;
			// 	modifyItem.item_comment = [
			// 		`(Deal: ${getDealName(modifyItem?.deal_info?.deal_type)} - ${
			// 			modifyItem?.deal_info?.deal_name
			// 		})`
			// 	];
			// 	allItems.push(modifyItem);
			// } else {
			// 	const newItem = structuredClone(items);
			// 	newItem.item_comment.push(
			// 		`(Deal: ${getDealName(newItem?.deal_info?.deal_type)} - ${
			// 			newItem?.deal_info?.deal_name
			// 		})`
			// 	);
			// 	allItems.push(newItem);
			// }
		} else {
			allItems.push(items);
		}
	});
	return allItems;
};

export const getDealName = (type: string) => {
	let name = type.replaceAll('_', ' ');
	name = name.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
	return name;
};

export const addCurrentTimeToDate = (date: any) => {
	const providedDate = new Date(date);
	const currentTime = new Date();
	providedDate.setHours(currentTime.getHours());
	providedDate.setMinutes(currentTime.getMinutes());
	providedDate.setSeconds(currentTime.getSeconds());
	const updatedDateString = providedDate.toString();
	return updatedDateString;
};
export const hasSpaceInBetween = (str: any) => {
	var pattern = /\w+\s\w+/;
	return pattern.test(str);
};

export const removeDuplicate = (array: any, key: string) => {
	const uniqueArray = array.filter(
		(obj: any, index: number, self: any) =>
			index === self.findIndex((o: any) => o[key] === obj[key])
	);
	return uniqueArray;
};

export const getArrayLast = (myArray: any) => {
	const [lastElement] = [...myArray].reverse();
	return lastElement;
};

export const time24To12 = (time: any) => {
	return moment(time, ['HH:mm:ss']).format('hh:mm A');
};
export const disableInputNumber = (event: any) => {
	const key = event.charCode || event.keyCode;
	if (key == 38 || key == 40) {
		event.preventDefault();
	} else {
		return;
	}
};

export const timeDifference = (end: string, start: string) => {
	var givenTime: any = new Date(start);
	var currentTime: any = new Date(end);
	var timeDifferenceInSeconds = Math.floor((currentTime - givenTime) / 1000);
	return timeDifferenceInSeconds;
};

export const secondsToDuration = (time: number, timesheet = false) => {
	var givenDurationInSeconds = time; // Replace with the desired duration in seconds

	var durationInMinutes = Math.floor(givenDurationInSeconds / 60);
	var durationInSeconds = givenDurationInSeconds % 60;

	var durationInHours = Math.floor(durationInMinutes / 60);
	durationInMinutes = durationInMinutes % 60;

	var durationInDays = Math.floor(durationInHours / 24);
	durationInHours = durationInHours % 24;

	if(timesheet){
		if(!durationInDays && !durationInHours && !durationInMinutes && durationInSeconds){
			return 0
		}else{
			return (
				(durationInDays ? durationInDays + 'd' : '') +
				(durationInHours ? (durationInDays ? ' ' + durationInHours + 'h' : durationInHours + 'h') : '') +
				(durationInMinutes ? ((durationInDays || durationInHours) ? ' ' + durationInMinutes + 'min' : durationInMinutes + 'min') : '')
			);
		}
	}else{
		return (
			(durationInDays ? durationInDays + ' days' : '') +
			(durationInHours ? (durationInDays ? ', ' + durationInHours + ' hours' : durationInHours + ' hours') : '') +
			(durationInMinutes ? (durationInHours ? ', ' + durationInMinutes + ' minutes' : durationInMinutes + ' minutes') : '') +
			(durationInSeconds ? (durationInMinutes ? ', ' + durationInSeconds + ' seconds' : durationInSeconds + ' seconds') : '')
		);
	}
};

export const localSalespersonSearch = (searchKey: string, item: any) => {
	if (!searchKey) {
		return true;
	}

	const searchKeyLowerCase = searchKey.toLowerCase();
	const fullNameLowerCase =
		item.data.first_name.toLowerCase() + ' ' + item.data.last_name.toLowerCase();

	return (
		fullNameLowerCase.includes(searchKeyLowerCase) ||
		item.data.first_name.toLowerCase().includes(searchKeyLowerCase) ||
		item.data.last_name.toLowerCase().includes(searchKeyLowerCase)
	);
};

export const secToHrs = (time: any) => {
	return (
		Math.floor(moment.duration(time, 'seconds').asHours()) +
		':' +
		moment.duration(time, 'seconds').minutes()
	);
	// return moment.duration(time, "seconds").format("hh:mm");
	// var duration = moment.duration(time, 'seconds');
	// return duration.format("hh:mm:ss");
	// const duration = moment.duration(time, 'seconds')
	// return moment.utc(duration.asMilliseconds()).format("HH:mm")
};

export const exportToExcel = (jsonData: any, fileName: string) => {
	// const csvContent =
	// 	'data:text/csv;charset=utf-8-sig,\ufeff' +
	// 	+jsonData.map((row: any) => Object.values(row).join(',')).join('\n');

	// const encodedUri = encodeURI(csvContent);
	// const link = document.createElement('a');
	// link.setAttribute('href', encodedUri);
	// link.setAttribute('download', fileName + '.csv');
	// document.body.appendChild(link);
	// link.click();
	// console.log(jsonData);
	const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
	const wb: XLSX.WorkBook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws);

	XLSX.writeFile(wb, fileName + '.xlsx');
};

export const isAnyInputEmpty = (data: any) => {
	const result: any = {};

	if (data.salesPerson && Object.keys(data.salesPerson).length > 0) {
		const salesPersonInputs = data.salesPerson.inputs;
		const salesPersonEmptyInputs = Object.values(salesPersonInputs).filter((input: any) => input.trim() === '');
		result.salesPerson = salesPersonEmptyInputs.length > 0;
	}

	if (data.customer && Object.keys(data.customer).length > 0) {
		const customerInputs = data.customer.inputs;
		const customerEmptyInputs = Object.values(customerInputs).filter((input: any) => input.trim() === '');
		result.customer = customerEmptyInputs.length > 0;
	}

	return (result);
}

export const formatDimensions = (dimensions: any) => {
	const roundedHeight = dimensions?.height;
	const roundedWidth = dimensions?.width;
	const roundedDepth = dimensions?.depth;

	return `${roundedHeight}H x ${roundedWidth}W x ${roundedDepth}D ${dimensions.unit}`;
}

export const validateDates = (startDate: any, endDate: any) => {
	const today = new Date();

	const startDateObj = new Date(startDate);
	const endDateObj = new Date(endDate);

	if (startDateObj > endDateObj) {
		return false;
	}

	if (startDateObj > today || endDateObj > today) {
		return false;
	}

	return true;
}

export const validateInventoryQuantityRange = (from: any, to: any) => {
	const POSITIVE_DIGIT_REGEX = new RegExp(/^\d*[0-9]\d*$/);

	if (from && !POSITIVE_DIGIT_REGEX.test(from)) {
		return false;
	}

	if (to && !POSITIVE_DIGIT_REGEX.test(to)) {
		return false;
	}

	if (from && !to) {
		return false;
	}

	if (!from && to) {
		return false;
	}

	return true;
}